import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1d": "#A37831",
    "col1l": "#E4B670",
    "col1n": "#D19532",
    "col2n": "#FFFF62",
    "col2s": "#DEC700"
}
function ShiMot127({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M36.25 4.95q1.2-1.1 1.9-3.5V.15q-1.9.85-3.4 1.75-.95.35-3.25.35-1.15 0-3.35-.5-.4-.2-.8-.35Q23.9 0 19.85 0q-3.8 0-7 1.25-.95.1-2.4.5-2.25.5-3.4.5-2.35 0-3.25-.35Q2.25 1 .4.15v1.3q.7 2.4 1.85 3.5Q3.4 6 5.4 6.3 0 11.9 0 19.8q0 1.65.25 3.2.5 3.55 2.25 6.6h.05q.2.4.45.8.15.2.3.45 1.1 1.6 2.55 3.05l.4.4q.25.25.5.45.4.35.85.7 5.25 4.25 12.25 4.25t12.2-4.15q.5-.4.95-.85.45-.4.85-.8 1.55-1.55 2.7-3.25 1.6-2.4 2.4-5.05.5-1.85.7-3.8.05-.95.05-1.9 0-1.4-.15-2.7-.5-3.85-2.35-7.1-1.25-2.15-3.05-4 1.25-.4 2.1-1.15z"
                    id="ShiMot127__Symbol_127_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1d}
                    d="M11.45 30.1q-.8.55-1.55 1.3-1.75 1.8-2.7 3.9 5.25 4.25 12.25 4.25t12.2-4.15q-1-2.2-2.8-4-.65-.65-1.3-1.15-3.9-.1-6.9-2.7-.65-.05-1.25-.05-.9 0-1.8.1-2.7 2.25-6.15 2.5m22.9-28.35q-.95.35-3.25.35-1.15 0-3.4-.5-2.2-.6-3.25-.6-2.6 0-4.2 1.15-.65.5-1.4 1.35-.75-.85-1.35-1.35Q15.85 1 13.3 1q-1.05 0-3.25.6-2.25.5-3.4.5-2.35 0-3.25-.35Q1.85.85 0 0v1.3q.7 2.4 1.85 3.5Q3.4 6.2 6.4 6.2q1.25 0 2.5-.15 1.2-.2 2.05-.2 2.8 0 4.45 1.1 1.2.8 3.55 3.55 2.2-2.75 3.35-3.55 1.65-1.1 4.5-1.1.8 0 2.05.2 1.2.15 2.45.15 3.05 0 4.55-1.4 1.2-1.1 1.9-3.5V0q-1.9.85-3.4 1.75z"
                    id="ShiMot127__Symbol_126_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1l}
                    d="M11.6 8.45h-.8q-5.05 0-8.65-4.05Q.8 2.9 0 1.2q.5 3.55 2.25 6.6h.05q.2.4.45.8.15.2.3.45 1.1 1.6 2.55 3.05l.4.4q.25.25.5.45.4.35.85.7.95-2.1 2.7-3.9.75-.75 1.55-1.3M38.7 3.8q.5-1.85.7-3.8-.95 2.5-2.8 4.55-3.55 4.05-8.55 4.05h-.35q.65.5 1.3 1.15 1.8 1.8 2.8 4 .5-.4.95-.85.45-.4.85-.8 1.55-1.55 2.7-3.25 1.6-2.4 2.4-5.05z"
                    id="ShiMot127__Symbol_121_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2n}
                    d="M21.75 18.6q.1.05.2.15 1.65.85 3.65.85 3.55 0 6-2.9 2.5-2.85 2.5-6.9 0-4.05-2.5-6.95Q29.15 0 25.6 0t-6.05 2.85q-2.45 2.8-2.5 6.75-.1-3.95-2.5-6.75Q12.05 0 8.5 0 6.05 0 4.05 1.45q-.85.6-1.6 1.4Q0 5.75 0 9.8q0 4.05 2.45 6.9.75.9 1.6 1.5 2 1.4 4.45 1.4 2.1 0 3.85-1l.3-.2.3-.2h8.15q.3.2.65.4z"
                    id="ShiMot127__Symbol_124_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2s}
                    d="M0 8.3l4.35 4.85 4-5q-.85-.6-1.55-1.5Q4.35 3.9 4.3 0q-.1 3.9-2.5 6.65-.85 1-1.8 1.65z"
                    id="ShiMot127__Symbol_123_0_Layer0_0_FILL"
                />
                <path
                    d="M188.35 283.55q-.7-.95-1.75-.95t-1.8.95q-.4.6-.6 1.3-.1.45-.1 1 0 1.35.7 2.25.75.95 1.8.95t1.75-.95q.75-.9.75-2.25 0-.55-.1-1-.2-.7-.65-1.3m12.05 0q-.7-.95-1.75-.95t-1.8.95q-.4.6-.6 1.3-.1.45-.1 1 0 1.35.7 2.25.75.95 1.8.95t1.75-.95q.75-.9.75-2.25 0-.55-.1-1-.2-.7-.65-1.3z"
                    id="ShiMot127__Layer1_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#ShiMot127__Symbol_127_0_Layer0_0_FILL"
                transform="translate(172.7 268.15)"
                id="ShiMot127__col1n"
            />
            <use
                xlinkHref="#ShiMot127__Symbol_126_0_Layer0_0_FILL"
                transform="translate(173.1 268.3)"
                id="ShiMot127__col1d"
            />
            <use
                xlinkHref="#ShiMot127__Symbol_121_0_Layer0_0_FILL"
                transform="translate(172.95 289.95)"
                id="ShiMot127__col1l"
            />
            <use
                xlinkHref="#ShiMot127__Symbol_124_0_Layer0_0_FILL"
                transform="translate(175.45 276)"
                id="ShiMot127__col2n"
            />
            <use
                xlinkHref="#ShiMot127__Symbol_123_0_Layer0_0_FILL"
                transform="translate(188.15 286.05)"
                id="ShiMot127__col2s"
            />
            <use xlinkHref="#ShiMot127__Layer1_0_FILL" />
        </g></g>
    )
}
export default ShiMot127
